/**
 * Reine Regeln fuer den Knopf "Bestehende Messungen löschen" an der Ofenkarte im
 * Umweltdatenformular (Phase 35, Plan 35-13, D-16, Sketch 020 Entscheidung 5).
 *
 * Der Knopf loescht nichts selbst -- er setzt die Messungsliste des Ofens im Formular auf leer;
 * geschrieben wird erst mit dem normalen Speichern der Meldung (@mantine/form, kein eigener
 * API-Aufruf). `DrehofenSection.tsx` verdrahtet die Sicherheitsabfrage, dieses Modul liefert nur
 * die Regeln dafuer -- kein React-Import, kein Formularzustand.
 */

export interface CanBulkDeleteParams {
  measurementCount: number;
  allowsOwnMeasurements: boolean;
  isAdmin: boolean;
}

/**
 * Der Knopf erscheint nur, wenn ueberhaupt Messungen vorhanden sind -- ein leerer Ofen hat
 * nichts zu loeschen. Zusaetzlich braucht es eine der beiden Berechtigungen:
 *
 * - `allowsOwnMeasurements`: das Werk hat das Anlegerecht an diesem Ofen und pflegt seine
 *   Messungen ohnehin von Hand, ein Neuimport ist dort ein Sonderfall, kein Regelfall.
 * - `isAdmin`: die Verwaltungsrolle. Das ist der eigentliche Anwendungsfall dieses Knopfs -- an
 *   den Oefen, an denen der VDZ selbst misst, ist `allowsOwnMeasurements` bewusst abgeschaltet
 *   (Phase 28, D-25/D-26: Anlegen und Loeschen gehoeren zum selben Recht). Genau dort will der
 *   Import einen Ofen fuer einen Neuimport leeren koennen, ohne dass ein Werksnutzer das Recht
 *   dafuer braeuchte. Die verbindliche Grenze zieht ohnehin die Meldungs-Policy im Backend
 *   (T-35-37) -- dieser Frontend-Schalter ist Komfort, keine Sicherheitsgrenze.
 */
export function canBulkDelete({
  measurementCount,
  allowsOwnMeasurements,
  isAdmin,
}: CanBulkDeleteParams): boolean {
  if (measurementCount === 0) return false;
  return allowsOwnMeasurements || isAdmin;
}

export interface BulkDeleteConfirmTextParams {
  kilnName: string;
  measurementCount: number;
}

/**
 * Text der Sicherheitsabfrage -- nennt Ofenname und Anzahl, Einzahl/Mehrzahl beachtet.
 */
export function bulkDeleteConfirmText({
  kilnName,
  measurementCount,
}: BulkDeleteConfirmTextParams): string {
  const noun = measurementCount === 1 ? 'Messung' : 'Messungen';
  return `Alle ${measurementCount} ${noun} von ${kilnName} unwiderruflich löschen?`;
}
